(function () {
  'use strict';
  var key = 'alicornio-vat-display';
  var root = document.documentElement;
  function syncButtons() {
    var inclusive = root.classList.contains('alicornio-vat-incl');
    document.querySelectorAll('[data-alicornio-vat-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', inclusive ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-alicornio-vat-toggle]');
    if (!button) return;
    var inclusive = root.classList.toggle('alicornio-vat-incl');
    try { localStorage.setItem(key, inclusive ? 'incl' : 'excl'); } catch (error) {}
    syncButtons();
  });
  window.addEventListener('storage', function (event) {
    if (event.key !== key) return;
    root.classList.toggle('alicornio-vat-incl', event.newValue === 'incl');
    syncButtons();
  });
  document.addEventListener('shopify:section:load', syncButtons);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
}());
